import { storeProvider } from 'ReduxHelpers';
import { isAlgorithmDataMessage } from './DataMessage';
import { voiceAgentSlice } from '../redux/voiceAgent';
import { type TutorBotDataReceivedCallback } from '../TutorBotVoiceAgent.types';

/*
algorithmMetadataEventListener is triggered when the agent to sends
down information about the algorithm (title and version) in an event, and stores that
information in redux
*/
export const algorithmMetadataEventListener: TutorBotDataReceivedCallback = ({ message, conversationId }) => {
    if (message && isAlgorithmDataMessage(message)) {
        storeProvider.dispatch(
            voiceAgentSlice.actions.updateConversationMetadata({ conversationId, ...message.payload }),
        );
    }
};
